// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bj156","colMin":"styles_colMin__S0rpe"};